/* Copyright (c) 2023 Xperi. All Rights Reserved. */

class CursorManager {
    static SERVICE_NAME = 'CursorStateResponse';

    private static subscribers = {};

    private static subscribeCount = 0;

    private static mCursorState = false;

    static onChange(state: boolean) {
        const keys = Object.keys(CursorManager.subscribers);
        this.mCursorState = state;

        keys.forEach((key) => {
            const notify = CursorManager.subscribers[key];
            if (typeof notify === 'function') notify(state);
        });
    }

    static subscribe(callback: Function): number {
        const ref = CursorManager.subscribeCount;
        CursorManager.subscribers[ref] = callback;
        CursorManager.subscribeCount += 1;
        return ref;
    }

    static unsubscribe(ref: number) {
        delete CursorManager.subscribers[ref];
    }

    static isCursorAppeared() {
        return this.mCursorState;
    }
}

export default CursorManager;
